import { GET_GENERAL_V1 } from '../config';

export const REQUIRED_TEXT = { msg: 'Required' };

export const checkRegex = (regex, value) => new RegExp(regex).test(value);

export const getItemFromStore = (key, defaultValue, store = localStorage) =>
  JSON.parse(store.getItem(key)) || defaultValue;
export const setItemToStore = (key, payload, store = localStorage) =>
  store.setItem(key, JSON.stringify(payload));

export const getRedirectUrl = () => {
  return GET_GENERAL_V1;
};
